import { useEffect, useState } from 'react';

import { SearchAssetResult } from '../../entity/SearchAsset';
import SearchAssetApi from '../../service/persistent/SearchAssetApi';

export const useRecommend = (preparedMaterialCategories: ReadonlyArray<number>) => {
  const [client] = useState(new SearchAssetApi());
  const [data, setData] = useState<SearchAssetResult>([]);
  const [materialCategories, setMaterialCategories] = useState(preparedMaterialCategories);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      setData([]);
      setIsError(false);

      try {
        const result = await client.getPreparedMaterialCategories(materialCategories);
        setData(result);
      } catch (error) {
        setIsError(true);
      }

      setIsLoading(false);
    };

    if (materialCategories != null && materialCategories.length !== 0) {
      fetchData();
    }
    // TODO: Implementation before introducing rules
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [materialCategories]);

  return [{ data, isLoading, isError }, setMaterialCategories] as const;
};
